<div class="y4c-root">

  <!-- ═════════ HERO ═════════ -->
  <section class="y4c-hero" id="home">
    <div class="y4c-wrap y4c-hero-grid">
      <div class="y4c-hero-copy">
        <span class="y4c-badge"><i class="ti ti-calendar-stats"></i> Whole-year structured learning and assessments</span>
        <h1 class="y4c-h1">Boost your child's Year 4 preparation</h1>
        <p class="y4c-hero-p">Weekly tests covering Maths, English, Creative Writing, VR and NVR, so your child builds strong foundations early and grows steady confidence.</p>
        <div class="y4c-hero-btns">
          <a class="y4c-btn y4c-btn-gold" (click)="scrollToCalendar()"><i class="ti ti-ticket"></i> Book a Year 4 topic test</a>
          <a class="y4c-btn y4c-btn-ghost" (click)="scrollToSubjects()">View subjects</a>
        </div>
      </div>

      <div class="y4c-subjects-card">
        <p class="y4c-sc-title"><i class="ti ti-clipboard-list"></i> Subjects covered</p>
        <div class="y4c-pill" *ngFor="let pill of heroPills">
          <span class="y4c-pill-ic"><i class="ti" [ngClass]="pill.icon"></i></span>
          <div><b>{{ pill.label }}</b><small>{{ pill.sub }}</small></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ STATS ═════════ -->
  <div class="y4c-wrap">
    <div class="y4c-stats">
      <div class="y4c-stat" *ngFor="let stat of lpStats">
        <div class="y4c-stat-n">{{ stat.number }}<span>{{ stat.suffix }}</span></div>
        <div class="y4c-stat-l">{{ stat.label }}</div>
      </div>
    </div>
  </div>

  <!-- ═════════ SUBJECTS ═════════ -->
  <section class="y4c-sec" id="lp-subjects">
    <div class="y4c-wrap">
      <div class="y4c-head y4c-reveal">
        <span class="y4c-tag"><i class="ti ti-books"></i> What we cover</span>
        <h2 class="y4c-h2">Step-by-step preparation for academic success</h2>
        <p class="y4c-lead">Weekly topic tests that help Year 4 students strengthen core skills and get exam-ready, one week at a time.</p>
      </div>
      <div class="y4c-subj-grid">
        <div class="y4c-subj y4c-reveal" *ngFor="let subject of lpSubjects">
          <div class="y4c-subj-ic"><i class="ti" [ngClass]="subject.icon"></i></div>
          <h3>{{ subject.title }}</h3>
          <p>{{ subject.desc }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ FEATURES ═════════ -->
  <section class="y4c-sec y4c-features">
    <div class="y4c-wrap">
      <div class="y4c-head y4c-reveal">
        <span class="y4c-tag"><i class="ti ti-settings-2"></i> How it works</span>
        <h2 class="y4c-h2">Trusted by parents, enjoyed by students</h2>
        <p class="y4c-lead">Preparation that stays structured, manageable and stress-free.</p>
      </div>
      <div class="y4c-feat-grid">
        <div class="y4c-feat y4c-reveal" *ngFor="let feature of lpFeatures">
          <div class="y4c-feat-ic"><i class="ti" [ngClass]="feature.icon"></i></div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.desc }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ BENEFITS ═════════ -->
  <section class="y4c-sec y4c-benefits">
    <div class="y4c-wrap">
      <div class="y4c-head y4c-reveal">
        <span class="y4c-tag"><i class="ti ti-star"></i> Your advantage</span>
        <h2 class="y4c-h2">Your Year 4 preparation, organised</h2>
        <p class="y4c-lead">Everything your child needs for a confident journey towards 11+ readiness.</p>
      </div>
      <div class="y4c-ben-grid">
        <div class="y4c-ben y4c-reveal" *ngFor="let benefit of lpBenefits">
          <div class="y4c-ben-ic"><i class="ti" [ngClass]="benefit.icon"></i></div>
          <div>
            <h4>{{ benefit.title }}</h4>
            <p>{{ benefit.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═════════ STEPS ═════════ -->
  <section class="y4c-sec" id="lp-steps">
    <div class="y4c-wrap">
      <div class="y4c-head y4c-reveal">
        <span class="y4c-tag"><i class="ti ti-flag"></i> Get started</span>
        <h2 class="y4c-h2">Ready in 3 easy steps</h2>
        <p class="y4c-lead">Join hundreds of families giving their children a structured head start.</p>
      </div>
      <div class="y4c-steps-row">
        <div class="y4c-step y4c-reveal" *ngFor="let step of lpSteps">
          <div class="y4c-step-n">{{ step.num }}</div>
          <h3>{{ step.title }}</h3>
          <p>{{ step.desc }}</p>
        </div>
      </div>
      <div class="y4c-steps-cta">
        <a class="y4c-btn y4c-btn-gold" (click)="scrollToCalendar()"><i class="ti ti-calendar-event"></i> See test dates</a>
      </div>
    </div>
  </section>

  <!-- ═════════ CALENDAR ═════════ -->
  <section class="y4c-cal" id="calendar-section">
    <div class="y4c-wrap">
      <div class="y4c-head">
        <span class="y4c-tag"><i class="ti ti-calendar"></i> Test calendar</span>
        <h2 class="y4c-h2">Find a test date and book</h2>
        <p class="y4c-lead">Filter by centre, month or format, then book your child's seat.</p>
      </div>

      <div class="y4c-filters">
        <div class="y4c-search">
          <i class="ti ti-search"></i>
          <input type="text" placeholder="Search by test name, centre or topic"
            [(ngModel)]="filters.search" (ngModelChange)="setFilter()" />
        </div>

        <div class="y4c-fgrid">
          <div class="y4c-field">
            <label>Test category</label>
            <div class="y4c-select">
              <select [(ngModel)]="filters.categoryId" (change)="setFilter()">
                <option [ngValue]="null">All</option>
                <option *ngFor="let cat of categories" [ngValue]="cat.category_id">{{ cat.category_name }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>

          <div class="y4c-field">
            <label>Test pattern</label>
            <div class="y4c-select">
              <select [(ngModel)]="filters.pattern" (change)="setFilter()">
                <option [ngValue]="null">All</option>
                <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>

          <div class="y4c-field">
            <label>Format</label>
            <div class="y4c-select">
              <select [(ngModel)]="filters.mode" (change)="setFilter()">
                <option [ngValue]="null">Both</option>
                <option value="Online Session">Online</option>
                <option value="Classroom Session">Face to face</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>

          <div class="y4c-field">
            <label>Month</label>
            <div class="y4c-select">
              <select [(ngModel)]="filters.month" (change)="setFilter()">
                <option [ngValue]="null">Any</option>
                <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>

          <div class="y4c-field">
            <label>Centre</label>
            <div class="y4c-select">
              <select [(ngModel)]="filters.center" (change)="setFilter()">
                <option [ngValue]="null">Any</option>
                <option *ngFor="let l of centers" [ngValue]="l">{{ l }}</option>
              </select>
              <i class="ti ti-chevron-down"></i>
            </div>
          </div>
        </div>

        <div class="y4c-factions">
          <span class="y4c-result"><b>{{ testList.length }}</b> session{{ testList.length === 1 ? '' : 's' }} found</span>
          <div class="y4c-fbtns">
            <button type="button" class="y4c-reset" (click)="resetAllFilters()"><i class="ti ti-refresh"></i> Reset filters</button>
            <a class="y4c-offer" [routerLink]="['/offer-free-resources']"><i class="ti ti-gift"></i> Claim offers</a>
          </div>
        </div>
      </div>

      <!-- LIST -->
      <div class="y4c-list test-card-listing-body">
        <ng-container *ngIf="testList && testList.length > 0; else nothingFound">

          <article class="y4c-row test-card"
            *ngFor="let t of visibleList; trackBy: trackByIndex"
            [class.is-range]="isRangeDate(t.test_date)">

            <!-- hidden fields kept for the jQuery search / location filter -->
            <span class="hidden f-test-name">{{ t.test_name }}</span>
            <span class="hidden f-course-name">{{ t.course }}</span>
            <span class="hidden f-category-name">{{ t.category }}</span>
            <span class="hidden f-type-name">{{ t.type }}</span>
            <span class="hidden f-location-name" *ngIf="t && t.all_location">{{ t.all_location }}</span>
            <span class="hidden f-location-name" *ngIf="t && !t.all_location">{{ t.location }}</span>
            <span class="hidden f-fees">{{ t.payment_method }}</span>

            <!-- Date + paper codes -->
            <div class="y4c-date">
              <ng-container *ngIf="isRangeDate(t.test_date); else singleDate">
                <span class="y4c-date-from">From</span>
                <span class="y4c-date-raw">{{ trimChar(stripFrom(t.test_date), 11) }}</span>
              </ng-container>
              <ng-template #singleDate>
                <ng-container *ngIf="dateParts(t.test_date) as d; else rawDate">
                  <span class="y4c-date-dow">{{ d.dow }}</span>
                  <span class="y4c-date-day">{{ d.day }}</span>
                  <span class="y4c-date-mon">{{ d.mon }}</span>
                </ng-container>
                <ng-template #rawDate>
                  <span class="y4c-date-raw">{{ trimChar(t.test_date, 11) }}</span>
                </ng-template>
              </ng-template>

              <div class="y4c-codes" *ngIf="paperCodes(t.test_name).length">
                <span class="y4c-code" *ngFor="let c of paperCodes(t.test_name)">{{ c }}</span>
              </div>
            </div>

            <!-- Info -->
            <div class="y4c-info">
              <div class="y4c-info-top">
                <span class="y4c-key" [ngClass]="isOnline(t) ? 'is-online' : 'is-f2f'">
                  <i class="ti" [ngClass]="isOnline(t) ? 'ti-world' : 'ti-users'"></i>
                  <span>{{ isOnline(t) ? 'Online' : 'Face to face' }}</span>
                </span>
                <span class="y4c-key is-centre" *ngIf="!isOnline(t) && (t.all_location || t.location)"
                  [title]="t.all_location || t.location">
                  <i class="ti ti-map-pin"></i>
                  <span>{{ trimChar(t.all_location || t.location) }}</span>
                </span>
                <span class="y4c-cat" *ngIf="t.category">{{ trimChar(t.category) }}</span>
              </div>

              <a class="y4c-name" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ t.test_name }}</a>
              <span class="y4c-type" *ngIf="t.type">{{ trimChar(t.type) }}</span>
            </div>

            <!-- Price -->
            <div class="y4c-price">
              <small>Price</small>
              <b [class.is-free]="t.payment_method === 'Free'">
                <ng-container *ngIf="t.payment_method === 'Free'; else priced">Free</ng-container>
                <ng-template #priced>£{{ t.test_fees }}</ng-template>
              </b>
            </div>

            <!-- Book -->
            <div class="y4c-act">
              <a class="y4c-book" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">Book seat</a>
            </div>
          </article>

          <div class="y4c-more load-button" *ngIf="testList.length > visibleCount">
            <button type="button" (click)="loadMore(true)">Load more sessions</button>
          </div>
        </ng-container>

        <ng-template #nothingFound>
          <div class="y4c-empty">
            <i class="ti ti-calendar-off"></i>
            <h4>No sessions match these filters</h4>
            <p>Try another month or centre, or reset the filters.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </section>

  <!-- ═════════ FAQ ═════════ -->
  <section class="y4c-faq">
    <div class="y4c-wrap">
      <div class="y4c-head">
        <span class="y4c-tag"><i class="ti ti-help-circle"></i> FAQs</span>
        <h2 class="y4c-h2">Questions parents ask</h2>
      </div>

      <div class="y4c-faq-list">
        <details *ngFor="let f of faqs">
          <summary>{{ f.q }} <i class="ti ti-plus"></i></summary>
          <p>{{ f.a }}</p>
        </details>
      </div>

      <div class="y4c-contact">
        <div>
          <h4>Still have questions?</h4>
          <p>Talk to our team directly.</p>
        </div>
        <div class="y4c-contact-links">
          <a class="y4c-clink" href="tel:+447464772331"><i class="ti ti-phone"></i> +44 7464 772331</a>
          <a class="y4c-clink" href="mailto:academy&#64;sehyog.co.uk"><i class="ti ti-mail"></i> academy&#64;sehyog.co.uk</a>
        </div>
      </div>

      <div class="y4c-social">
        <span aria-label="LinkedIn"><i class="ti ti-brand-linkedin"></i></span>
        <span aria-label="Facebook"><i class="ti ti-brand-facebook"></i></span>
        <span aria-label="YouTube"><i class="ti ti-brand-youtube"></i></span>
        <span aria-label="X"><i class="ti ti-brand-x"></i></span>
        <span aria-label="Instagram"><i class="ti ti-brand-instagram"></i></span>
      </div>

      <p class="y4c-disclaimer">SEHYOG is an educational institute dedicated to providing comprehensive support to KS2, 11plus, KS3, GCSE and A-Level students to achieve excellence in education and personal development with honesty and transparency. The sessions, workshops and webinars conducted by SEHYOG do not guarantee 100% success in the real exams. No claim is made as to the accuracy or authenticity of the content of the sessions, workshops or webinars, or of information shared via email, website or social media. SEHYOG and its volunteers and staff do not accept any liability to any person or firm for the information or advice (or the use of such information or advice) provided in the sessions, workshops, email or on social media. The information is provided on the basis that all persons accessing it undertake responsibility for assessing its relevance and accuracy.</p>
    </div>
  </section>
</div>
